import { render, staticRenderFns } from "./LangPicker.vue?vue&type=template&id=77ae9ec4&scoped=true&"
import script from "./LangPicker.vue?vue&type=script&lang=js&"
export * from "./LangPicker.vue?vue&type=script&lang=js&"
import style0 from "./LangPicker.vue?vue&type=style&index=0&id=77ae9ec4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ae9ec4",
  null
  
)

export default component.exports